<ng-container *ngIf="!isMobile; else mobileView">
  <ion-content scrollEvents="true" (ionScroll)="onScroll($event)">
    <codere-slider
      *ngIf="!!lstBanners?.length && sliderVisible && !globalVars?.FEATURES.NewCarouselActivated"
      [slides]="lstBanners"
      [controls]="isDesktop"
      (clickedSlide)="clickBanner($event)"
    />
    <codere-slider-csv
      *ngIf="!!lstNewBanners?.length && sliderVisible && globalVars?.FEATURES.NewCarouselActivated"
      [banners]="lstNewBanners"
    />

    <!-- Temporary promotion -->
    <div padding *ngIf="globalVars?.user?.logged && globalVars?.FEATURES.TemporaryPromoEnabled">
      <div class="has-background-dark temporary-promotion--container">
        <div class="temporary-promotion--image">
          <img [src]="temporaryPromotionConfig?.bannerMobileImage" alt="" />
        </div>
        <ion-buttons padding-horizontal class="temporary-promotion--buttons">
          <button ion-button clear start tappable (click)="openPromos()">+Info</button>
          <button class="background-color-secondary" ion-button end tappable (click)="openTemporaryPromotion()">
            {{temporaryPromotionConfig?.openPromotionButtonText}}
          </button>
        </ion-buttons>
      </div>
    </div>

    <!-- Marquee Desktop -->
    <sb-marquee *ngIf="marqueeData?.length > 0" [marqueeData]="marqueeData" />

    <!-- Ahora en directo Desktop -->
    <ng-container *ngIf="!restartingPolling && liveEvents$ | async as liveEvents">
      <sb-header-with-counter
        *ngIf="liveEvents.length > 0"
        [count]="LiveEventsCount"
        (onClick)="navigate(null, 'live', null)"
      />
      <ng-container *ngFor="let sport of liveEvents">
        <sb-header-with-counter [sport]="sport" />
        <sports-grid
          *ngFor="let event of sport?.Events;let index = index;trackBy: trackBy"
          [event]="event"
          (navigate)="navigate($event, 'live-market', sport?.key)"
          [separator]="index < sport?.Events.length - 1"
        >
          <sports-grid-content-teams [event]="event" content />
          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          />
          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          />

          <sports-group
            *ngFor="let game of event?.Games"
            (clicked)="navigate(event, 'market', sport?.key, game?.GameType)"
            [betType]="game?.DisplayTypeName"
            sb-markets
          >
            <sports-bet-button
              *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              (bet)="bet($event, event, game?.Name, '1')"
              [locked]="result?.Locked"
              [home]="event.teamHome"
              [away]="event.teamAway"
              [sport]="event?.SportHandle"
              [selected]="newTicketFacade?.hasResult(result.NodeId)"
            />
          </sports-group>
          <sb-counter
            counter-button
            *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
            [count]="event.ChildrenCount"
            (onClick)="navigate(event, 'live-market', sport?.key)"
          />
        </sports-grid>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="restartingPolling && firstLoadDone">
      <p class="noEventPadding restartingPolling">
        <span>Se ha detectado un problema en el servicio.</span>
        <span>{{restartingPollingMessage}}</span>
      </p>
    </ng-container>
    <!-- Marquee Betbuilder Desktop -->
    <sb-marquee-betbuilder *ngIf="betbuilderEventsData?.length > 0" [betbuilderEventsData]="betbuilderEventsData" />

    <!-- Apuestas Destacadas Desktop -->
    <ng-container *ngIf="sportFilters?.length > 0" #highlights>
      <sb-header-with-counter [text]="'Apuestas Destacadas'" />
      <div class="ion-segment-wrapper">
        <ion-segment [value]="sportFilterSelected?.SportHandle" class="ion-button--reduced" [scrollable]="true">
          <ion-segment-button
            [value]="button?.SportHandle"
            layout="icon-start"
            *ngFor="let button of sportFilters"
            (click)="setCurrentFilter(button)"
          >
            <i [ngClass]="'icon-' + button?.SportHandle" class="codere-icon"></i>
            <ion-label>{{ button?.SportName }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>

      <sports-grid
        *ngFor="let event of sportEvents?.Events; trackBy: utils?.trackBy"
        [event]="event"
        [mode]="event?.mode"
        [special]="sportbookService?.isSpecialMarket(event?.LeagueName)"
        (navigate)="navigate($event, 'market', sportEvents?.SportHandle)"
        [separator]="true"
      >
        <ng-container
          *ngTemplateOutlet="event?.mode === 'teams' ? teams : expanded; context: { event: event }"
          content
        />

        <sports-group
          *ngFor="let game of event?.Games"
          (clicked)="navigate(event, 'market', sportEvents?.SportHandle, game?.GameType)"
          [betType]="game?.DisplayTypeName"
          sb-markets
        >
          <sports-bet-button
            *ngFor="let result of game?.Results; let index = index;"
            [type]="game?.GameType"
            [typeName]="game?.DisplayTypeName"
            [game]="result"
            [results]="game?.Results"
            [index]="index"
            (bet)="bet($event, event, game?.Name, '2')"
            [locked]="result?.Locked"
            [home]="event?.teamHome"
            [away]="event?.teamAway"
            [sport]="event?.SportHandle"
            [selected]="newTicketFacade?.hasResult(result.NodeId)"
          />
        </sports-group>
        <sb-counter
          counter-button
          *ngIf="!!event?.ChildrenCount && event?.mode !== 'expanded'"
          [count]="event.ChildrenCount"
          (onClick)="navigate(event, 'market', sportEvents?.SportHandle)"
        />
      </sports-grid>
    </ng-container>
    <ng-container>
      <p class="noEventPadding" *ngIf="sportEvents?.Events.length < 1 && sportFilters?.length > 0">
        No hay apuestas destacadas en estos momentos.
      </p>
    </ng-container>

    <ng-container *ngIf="restartingPolling && !firstLoadDone">
      <p class="noEventPadding restartingPolling">
        <span>Se ha detectado un problema en el servicio.</span>
        <span>{{restartingPollingMessage}}</span>
      </p>
    </ng-container>
    <ng-container>
      <codere-footer />
    </ng-container>
  </ion-content>

  <!--Overview Pages-->
  <ng-template #teams let-event="event" content>
    <sports-grid-content-teams [event]="event" content />
  </ng-template>
  <ng-template #expanded let-event="event" content>
    <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content />
  </ng-template>
</ng-container>

<ng-template #mobileView>
  <ion-content
    scrollEvents="true"
    class="getting-started"
    (ionScroll)="onScroll($event)"
    [ngClass]="{'no-scroll': globalVars?.iosScrollHide}"
  >
    <div class="sb-sticky">
      <sb-icon-bar
        [items]="carousels$ | async"
        [selectedItem]="{ SportHandle: ''}"
        (selectItem)="clickItemCarrouselSportBook($event)"
      />
    </div>
    <codere-slider
      *ngIf="!!lstBanners?.length && sliderVisible && !globalVars?.FEATURES.NewCarouselActivated"
      [slides]="lstBanners"
      [controls]="isDesktop"
      (clickedSlide)="clickBanner($event)"
    />
    <codere-slider-csv
      *ngIf="!!lstNewBanners?.length && sliderVisible && globalVars?.FEATURES.NewCarouselActivated"
      [banners]="lstNewBanners"
    />

    <div padding *ngIf="globalVars?.user?.logged && globalVars?.FEATURES.TemporaryPromoEnabled">
      <div class="has-background-dark temporary-promotion--container">
        <div class="temporary-promotion--image">
          <img [src]="temporaryPromotionConfig.bannerMobileImage" alt="" />
        </div>
        <ion-buttons padding-horizontal class="temporary-promotion--buttons">
          <button ion-button clear start tappable (click)="openPromos()">+Info</button>
          <button class="background-color-secondary" ion-button end tappable (click)="openTemporaryPromotion()">
            {{temporaryPromotionConfig?.openPromotionButtonText}}
          </button>
        </ion-buttons>
      </div>
    </div>

    <!-- Marquee -->
    <sb-marquee *ngIf="marqueeData?.length > 0" [marqueeData]="marqueeData" />

    <!-- Ahora en directo MOBILE -->
    <ng-container *ngIf="!restartingPolling && liveEvents$ | async as liveEvents">
      <!-- <ng-container *ngIf="liveEvents$ | async as liveEvents"> -->
      <sb-header-with-counter
        *ngIf="liveEvents.length > 0"
        [count]="LiveEventsCount"
        (onClick)="navigate(null, 'live')"
      />
      <ng-container *ngFor="let sport of liveEvents">
        <sb-header-with-counter [sport]="sport" />
        <sports-grid
          *ngFor="let event of sport?.Events; let index = index; trackBy: trackBy"
          [event]="event"
          (navigate)="navigate($event, 'live-market', sport)"
          [separator]="index < sport?.Events.length - 1"
        >
          <sports-grid-content-teams [event]="event" content />
          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          />
          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          />

          <sports-group
            *ngFor="let game of event?.Games"
            (clicked)="navigate(event, 'market', sport?.key, game?.GameType)"
            [betType]="game?.DisplayTypeName"
            sb-markets
          >
            <sports-bet-button
              *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              (bet)="bet($event, event, game?.Name, '1')"
              [locked]="result?.Locked"
              [home]="event.teamHome"
              [away]="event.teamAway"
              [sport]="event?.SportHandle"
              [selected]="newTicketFacade?.hasResult(result.NodeId)"
            />
          </sports-group>
        </sports-grid>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="restartingPolling && firstLoadDone">
      <p class="noEventPadding restartingPolling">
        <span>Se ha detectado un problema en el servicio.</span>
        <span>{{restartingPollingMessage}}</span>
      </p>
    </ng-container>

    <sb-marquee-betbuilder *ngIf="betbuilderEventsData?.length > 0" [betbuilderEventsData]="betbuilderEventsData" />

    <ng-container *ngIf="sportFilters?.length > 0">
      <sb-header-with-counter [text]="'Apuestas Destacadas'" />
      <div class="ion-segment-wrapper">
        <ion-segment [value]="sportFilterSelected?.SportHandle" [scrollable]="true" mode="md">
          <ion-segment-button
            [value]="button?.SportHandle"
            layout="icon-start"
            *ngFor="let button of sportFilters"
            (click)="setCurrentFilter(button)"
          >
            <i [ngClass]="'icon-' + button?.SportHandle" class="codere-icon"></i>
            <ion-label>{{ button?.SportName }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
      <!--TEMPLATE 3 - sixpax or not--->
      <ng-container *ngFor="let event of sportEvents?.Events; let index = index; trackBy: utils?.trackBy">
        <sports-grid
          *ngIf="!event?.isSixPack"
          [event]="event"
          [mode]="event?.mode"
          [hasBets]="!!event?.Games?.length"
          [special]="sportbookService?.isSpecialMarket(event?.LeagueName)"
          (navigate)="navigate($event, 'market')"
          [separator]="index < sportEvents?.Events.length - 1"
        >
          <!--template outlet for content-->
          <ng-container
            *ngTemplateOutlet="event?.mode === 'teams' ? teams : expanded; context: {event: event}"
            content
          />
          <sb-overview-score-sets
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
            [sportHandle]="event?.SportHandle"
            [scoreboard]="event?.liveData"
            scoreboard
          />
          <sb-overview-score-regular
            *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
            [scoreboard]="event?.liveData"
            scoreboard
          />
          <sports-group *ngFor="let game of event?.Games" [betType]="game?.DisplayTypeName" sb-markets>
            <sports-bet-button
              *ngFor="let result of game?.Results; let index = index;"
              [type]="game?.GameType"
              [typeName]="game?.DisplayTypeName"
              [game]="result"
              [results]="game?.Results"
              [index]="index"
              [locked]="result?.Locked"
              [home]="event?.teamHome"
              [sport]="event?.SportHandle"
              [away]="event?.teamAway"
              [sport]="event?.SportHandle"
              (bet)="bet($event, event, game?.Name, '2')"
              [selected]="newTicketFacade?.hasResult(result.NodeId)"
            />
          </sports-group>
        </sports-grid>
        <!-- SIX PACK -->
        <ng-container *ngIf="event?.isSixPack">
          <sb-grid-header
            [titleLeft]="'Ganador'"
            [titleCenter]="'Handicap'"
            [titleRight]="'Totales'"
            [market]="event?.sixPack"
          />
          <sports-grid-helper *ngIf="event?.isSixPack" [bottomSpaceI]="true" [bottomSeparatorI]="true">
            <sports-grid
              [mode]="event?.sixPack?.displayMode"
              [event]="event?.sixPack"
              [special]="sportbookService?.isSpecialMarket(event?.LeagueName)"
              (navigate)="navigate($event,'market', sportEvents?.key)"
            >
              <sports-grid-content-single
                [title]="event?.sixPack?.teamHome"
                [subtitle]="event?.sixPack?.pitcherHome"
                content
              />

              <sports-group sb-markets [sixPack]="event?.isSixPack" [betType]="event?.sixPack?.DisplayTypeName">
                <sports-bet-button
                  *ngFor="let result of (event?.sixPack?.combinedResults)[0]?.results as game; let indexCombinedBets = index; trackBy: utils?.trackBy"
                  [typeName]="event?.sixPack?.DisplayTypeName"
                  [type]="result?.GameType"
                  [game]="result"
                  [isCombined]="event?.sixPack?.isCombined"
                  [results]="event?.sixPack?.GroupResults"
                  [index]="indexCombinedBets"
                  [locked]="result?.Locked"
                  [home]="event?.sixPack?.teamHome"
                  [away]="event?.sixPack?.teamAway"
                  [sport]="event?.SportHandle"
                  (bet)="bet($event, event, result?.Name, '3')"
                  [selected]="newTicketFacade?.hasResult(result.NodeId)"
                />
              </sports-group>
            </sports-grid>
            <sports-grid-helper *ngIf="event?.isSixPack" [betweenI]="true" />
            <sports-grid
              *ngIf="event?.isSixPack"
              [mode]="event?.sixPack?.displayMode"
              [event]="event?.sixPack"
              [special]="sportbookService?.isSpecialMarket(event?.LeagueName)"
              (navigate)="navigate(event?.sixPack)"
            >
              <sports-grid-content-single
                [title]="event?.sixPack?.teamAway"
                [subtitle]="event?.sixPack?.pitcherAway"
                content
              />
              <sports-group sb-markets [sixPack]="event?.isSixPack" [betType]="event?.sixPack?.DisplayTypeName">
                <sports-bet-button
                  *ngFor="let result of (event?.sixPack?.combinedResults)[1]?.results; let indexCombinedBets = index; trackBy: utils?.trackBy"
                  [typeName]="event?.sixPack?.DisplayTypeName"
                  [type]="result?.GameType"
                  [game]="result"
                  [isCombined]="event?.sixPack?.isCombined"
                  [results]="event?.sixPack?.GroupResults"
                  [locked]="result?.Locked"
                  [index]="indexCombinedBets"
                  [home]="event?.sixPack?.teamHome"
                  [away]="event?.sixPack?.teamAway"
                  [sport]="event?.SportHandle"
                  (bet)="bet($event, event, result?.Name, '4')"
                  [selected]="newTicketFacade?.hasResult(result.NodeId)"
                />
              </sports-group>
            </sports-grid>
          </sports-grid-helper>
        </ng-container>
      </ng-container>
      <ng-container>
        <p class="noEventPadding" *ngIf="sportEvents?.Events.length < 1">
          No hay apuestas destacadas en estos momentos.
        </p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="restartingPolling && !firstLoadDone">
      <p class="noEventPadding restartingPolling">
        <span>Se ha detectado un problema en el servicio.</span>
        <span>{{restartingPollingMessage}}</span>
      </p>
    </ng-container>
    <ng-container>
      <codere-footer></codere-footer>
    </ng-container>
  </ion-content>
  <!--Overview Pages-->
  <ng-template #teams let-event="event" content>
    <sports-grid-content-teams [event]="event" content />
  </ng-template>
  <ng-template #expanded let-event="event" content>
    <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content />
  </ng-template>
</ng-template>
